import { UserPermission } from '../enums/user-permission.enum';
import { UserIdp } from '../../users/enums/user-idp.enum';

export const metaPath = 'https://bitdefender.com/app_meta';

export class JwtUser {
    private readonly id: string;
    private readonly _meta: JwtMetadata;
    private readonly permissions: UserPermission[];
    private readonly exp: number;
    private readonly idpRegion: string | null;

    constructor(jwtTokenClaims: any) {
        this._meta = jwtTokenClaims[metaPath];
        this.id = this._meta.userId;
        // add permissions and also inject "Authenticated"
        this.permissions = jwtTokenClaims.permissions || [];
        this.permissions.push(UserPermission.Authenticated);
        this.exp = jwtTokenClaims.exp;
        this.idpRegion = jwtTokenClaims.idpRegion;
    }

    get meta(): JwtMetadata {
        return this._meta;
    }

    public get Permissions(): UserPermission[] {
        return this.permissions;
    }

    public get CompanyId(): string {
        return this._meta.companyId;
    }

    public get UserId(): string {
        return this.id;
    }

    public get UserIdp(): UserIdp {
        return this._meta.userIdp;
    }

    public get IdpRegion(): string | null {
        return this.idpRegion;
    }

    public get Name(): string {
        return this._meta.name;
    }

    public get Email(): string {
        return this._meta.email;
    }

    public get Exp(): number {
        return this.exp;
    }

    public PermissionExist(permissions: UserPermission[]): boolean {
        let validPermissions = true;

        permissions.forEach((permission: UserPermission) => {
            if (!this.permissions.includes(permission)) validPermissions = false;
        });

        return validPermissions;
    }
}

export interface JwtMetadata {
    termsAndConditionsAccepted: Boolean;
    companyId: string;
    companyPath: string;
    userId: string;
    userIdp: UserIdp;
    email: string;
    name: string;
}
